import StaticContentClient from '../common/StaticContentClient';

export class Dibels8StaticContentClient extends StaticContentClient {
    static BASE_URL = '/dibels8-assessment/static/content';

    static REMINDERS_URL = `${Dibels8StaticContentClient.BASE_URL}/reminders.json`;

    static INSTRUCTIONS_URL = `${Dibels8StaticContentClient.BASE_URL}/instructions.json`;
}

export default Dibels8StaticContentClient;
